module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg5-df298b19a4c98e6c1d4084dea65cb871.jpg";